//* Libraries imports
import { useMutation } from "@tanstack/react-query";

//* Axios Import
import { publicApi } from "../../../services/apis/configs/apiClient";

//* Schema imports
import {
  sendEmailRecoveryPasswordSchema,
  sendEmailRecoveryPasswordSuccessSchema,
  type SendEmailRecoveryPasswordRequest,
} from "../../../schemas/common/recovery-password/recorvery-password";

export type SendEmailRecoveryPasswordParams = SendEmailRecoveryPasswordRequest;

async function sendEmailRecoveryPassword(params: SendEmailRecoveryPasswordParams) {
  try {

    const validatedData = sendEmailRecoveryPasswordSchema.parse(params);
    
    const { cpf } = validatedData;
    const url = "/student_portal/public/send_reset_password_email";
    
    const response = await publicApi.post(url, { cpf });
    
    return sendEmailRecoveryPasswordSuccessSchema.parse(response);


  } catch (err: any) {
    const errorMessage = err.response?.data?.error?.message || err.response?.data?.message;
    
    if (errorMessage) {
      if (errorMessage === 'Nenhum usuário encontrado com este CPF') {
        throw new Error("Usuário não encontrado com este CPF");
      }
      
      if (errorMessage === 'Este CPF não pertence a um estudante') {
        throw new Error("Este CPF não pertence a um estudante");
      }
      
      if (errorMessage === 'Instituição não encontrada') {
        throw new Error("Instituição não encontrada");
      }
      
      throw new Error(errorMessage);
    }
    
    console.error("Erro ao enviar email de recuperação de senha:", err);
    throw new Error("Erro interno do servidor. Tente novamente mais tarde.");
  }
}

export function useSendEmailRecoveryPassword() {
  return useMutation({
    mutationFn: sendEmailRecoveryPassword,
  });
}